import { Component, OnInit, Input, Output, EventEmitter, OnDestroy  } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MaterializeAction, MaterializeDirective } from 'angular2-materialize';

import { ActivityService, Activity, PdfActivityDisplayLabels } from '../../services/activity.service';
import { ActivityClassificationService } from '../../services/activity-classification.service';

import { QuotationFunctionData } from '../../quotation-activity-functions';
import { UnitService } from '../../services/unit.service';
import { Subscription } from 'rxjs';
import { ProductCmpaService } from '../../services/product-cmpa.service';

@Component({
	selector: 'app-create-activity',
	templateUrl: './create-activity.component.html',
	styleUrls: ['./create-activity.component.css', '../../app.component.css']
})

export class CreateActivityComponent implements OnInit, OnDestroy {

	activityForm: FormGroup;
	activity: any;

	classifications = {};
	classificationInit: any;
	classificationText = '';

	units: any[] = [];
	@Input() unitInit: string;
	@Output() unitModelChange = new EventEmitter();

	modalActions = new EventEmitter<string|MaterializeAction>();
	modalParams = [ {
		dismissible: false,
		complete: function() {
			// console.log('Modal : Close');
		}
	} ];

	classificationForm: FormGroup;
	classification: any;

	gacSubs: Subscription;
	gmuSubs: Subscription;
	prCmpaSub: Subscription;

	activityFunctionDatas: any;
	generalfunctionSelects: any[];
	sectionfunctionSelects: any[];

	unique: any = {
		papel: {prCmpaId: '', prCmpaDescription: ''}
	};
	activityIsGeneral: boolean;
	currentFunction: any;
	dataCalc: number;
	labels: string[];
	appliesPrVnta: boolean = false;
	appliesOdP: boolean = false;
	pdfDisplay: Activity['pdfDisplay'] = {key1: false, key2: false, key3: false};
	pdfLabels = PdfActivityDisplayLabels;

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private activityService: ActivityService,
		private activityClassificationService: ActivityClassificationService,
		private unitService: UnitService,
		private prCmpaService: ProductCmpaService,
		private quotationFunctionData: QuotationFunctionData
	) {
		this.activityFunctionDatas = this.quotationFunctionData.functionData;
		this.generalfunctionSelects = [];
		this.sectionfunctionSelects = [];
		quotationFunctionData.selectArray.map(data => {
			if(data.isGeneral) this.generalfunctionSelects.push(data);
			else this.sectionfunctionSelects.push(data);
		})
		this.loadClassifications();
		this.loadUnits();


		this.prCmpaSub = this.prCmpaService.getPrCmpas().subscribe(prCmpas => {
			this.rowsRead[0] = prCmpas.map(({characs, prices, ...prCmpa}) => {
				prCmpa.prTypeName = prCmpa.data.name;
				prCmpa.characs = characs.reduce((acc, cur, index) => {
					let unit = this.units.find(({id}) => id == cur.unitId.id);
					let symbol = unit ? unit.symbol : '';
					return acc + `${index ? ', ' : ''}${cur.name}: ${cur.value}${symbol}`;
				}, '');
				prCmpa.higherPrice = Math.max(0, ...prices.map(({price}) => price));
				console.log(prices, prCmpa.higherPrice);
				this.prCmpas[prCmpa.id] = {...prCmpa};
				return prCmpa;
			});
		});
	}

	ngOnInit() {
		this.activityForm = this.fb.group({
			name: ['', Validators.required],
			classification: ['', Validators.required],
			quantityPricesFunction: ['', Validators.required],
			value: ['', Validators.required],
			unit: ['', Validators.required],
			minPrice: 0,
			ranges: this.fb.array([]),
			prices: this.fb.array([])
		});

		this.classificationForm = this.fb.group({
			nameCla: ['', Validators.required],
			descriptionCla: ['', Validators.required],
			perSection: ['']
		});
	}

	get qpFunction(){ return this.activityForm.get('quantityPricesFunction').value; }

	onSubmitActivity() {
		this.activity = this.saveActivity();

		this.activityService.addActivity(this.activity);
		this.router.navigate(['/activities']);
	}

	saveActivity() {
		const currentDate = new Date();
		const activityJson = {
			active: true,
			activityClassificationRef: this.classifications[this.activityForm.get('classification').value].id,
			isGeneral: this.classifications[this.activityForm.get('classification').value].isGeneral,
			quantityPricesFunction: this.activityForm.get('quantityPricesFunction').value,
			createdAt: currentDate,
			measurementUnitRef: this.activityForm.get('unit').value,
			name: this.activityForm.get('name').value,
			updatedAt: currentDate,
			value: this.activityForm.get('value').value,
			dataCalc: this.dataCalc,
			ranges: this.ranges.value ? this.ranges.value : [],
			prices: this.prices.value ? this.prices.value.map(object => object.price) : [],
			appliesPrVnta: this.appliesPrVnta,
			appliesOdP: this.appliesOdP,
			unique: this.quotationFunctionData.functionData[this.qpFunction].hasUnique && this.unique[this.qpFunction] || {},
			minPrice: this.activityForm.value.minPrice,
			pdfDisplay: this.pdfDisplay
		};
		return activityJson;
	}

	loadClassifications() {
		this.gacSubs = this.activityClassificationService.getActivityClassifications().subscribe(tempClassifications => {
			const dataClassifications = {};

			for (const idx in tempClassifications) {
				dataClassifications[tempClassifications[idx].name] = null;

				this.classifications[tempClassifications[idx].name] = { id: tempClassifications[idx].id$, isGeneral: !tempClassifications[idx].perSection};
				this.classifications[tempClassifications[idx].id$] = { name: tempClassifications[idx].name, isGeneral: !tempClassifications[idx].perSection };
			}

			this.classificationInit = {
				'data': dataClassifications,
				onAutocomplete: (val) => {
					// console.log(val);
					// console.log(this.jobs[val]);
				}
			};
		});
	}

	loadUnits() {
		this.gmuSubs = this.unitService.getUnits().subscribe(tempUnits => {
			this.units = tempUnits;

		  this.unitInit = tempUnits[0].id;
		});
	}

	onBlurClassification() {
		if (!this.classifications[this.classificationText]) {
			this.classificationText = '';
		}
	}

	changeUnit(unitValue) {
		this.unitModelChange.emit(unitValue);
	}

	openModal() {
		this.modalActions.emit({ action: 'modal', params: ['open'] });
	}

	closeModal() {
		this.modalActions.emit({ action: 'modal', params: ['close'] });
	}

	onSubmitClassification() {
		this.classification = this.saveClassification();

		this.activityClassificationService.postActivityClassification(this.classification);
		this.classificationForm.reset();

		this.loadClassifications();

		this.closeModal();

		this.classificationText = this.classification.name;
	}

	saveClassification() {
		const currentDate = new Date();

		const classificationJson = {
			active: 1,
			createdAt: currentDate,
			description: this.classificationForm.get('descriptionCla').value,
			name: this.classificationForm.get('nameCla').value,
			perSection: !!this.classificationForm.get('perSection').value,
			updatedAt: currentDate
		};

		return classificationJson;
	}
	
	onChangeClassification(className){
		if(!this.validClassification) return;
		const c = this.classifications[className];
		if(c) this.activityIsGeneral = c.isGeneral;
		if(c.isGeneral) var array = this.generalfunctionSelects;
		else var array = this.sectionfunctionSelects;
		this.activityForm.get('quantityPricesFunction').patchValue(array[0].value);
		this.onChangeFunction(array[0].value);
	}
	onChangeFunction(functionValue){
		this.currentFunction = this.activityFunctionDatas[functionValue];
		this.dataCalc = this.currentFunction.dataCalc;
		while(this.prices.length > 0) this.prices.removeAt(0); //reset prices por pushing
		this.labels = this.currentFunction.labels;
		if (this.currentFunction.dataCalc === 0 && this.ranges.length === 0) this.ranges.push(this.rangeForm());
		else if(this.currentFunction.dataCalc > 0 ) for(var i = 0; i < this.currentFunction.dataCalc; i++) this.prices.push(this.priceForm());
	}
	
	get ranges(): FormArray {
		return this.activityForm.get('ranges') as FormArray;
	}
	get prices(): FormArray {
		return this.activityForm.get('prices') as FormArray;
	}
	
	rangeForm() {
		return this.fb.group({
			min: [0, Validators.required],
			max: [0, Validators.required],
			price: [0, Validators.required]
		});
	}
	priceForm(){
		return this.fb.group({
			price: ['', Validators.required]
		});
	}

	get validClassification(){
		return !!this.classifications[this.classificationText];
	}

	addNewRange() {
		this.ranges.push(this.rangeForm());
	}

	removeRange(index: number) {
		this.ranges.removeAt(index);
	}

	ngOnDestroy() {
		this.gacSubs.unsubscribe();
		this.gmuSubs.unsubscribe();
	}



	//////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA
	selectedIds: string[] = [];
	prCmpas = {};
	get selectedPrCmpaId(): string { return this.selectedIds[0]; }
	
	get readValid(){ return true };// this.selectedPrCmpaId || this.qpFunction != 'papel' };
	
	currentReadIndex: number;
	rowsRead = [[]];
	columnsRead = [
		[//prCmpa
			{title: 'Nombre', name: 'name',sort: 'asc'},
			{title: 'Características', name: 'characs'},
			{title: 'Clasificación' , name: 'prTypeName'},
			{title: 'Código', name: 'code'}
		]
	]

	modalActionsRead = new EventEmitter<string|MaterializeAction>();
	modalParamsRead = [{dismissible: true}];
	openModalRead(index: number) {
		this.currentReadIndex = index;
		this.data = this.rowsRead[index];
		
		this.config = this.configs[index];
	
		this.onChangeTable(this.config);
		this.modalActionsRead.emit({ action: 'modal', params: ['open'] });
	}
	closeModalRead() {
		this.modalActionsRead.emit({ action: 'modal', params: ['close'] });
	}
	selectRead(data: any): any{
		this.selectedIds[this.currentReadIndex] = data.row.id;
		if(this.qpFunction == 'papel'){
			this.unique.papel.prCmpaId = this.selectedPrCmpaId;
			this.unique.papel.prCmpaDescription = `${data.row.name} - ${data.row.characs}`;
			this.activityForm.get('prices').setValue([{price: this.prCmpas[this.selectedPrCmpaId].higherPrice}]);
		}
		this.closeModalRead();
	}
	unselectRead(index: number){
		this.closeModalRead();
		this.selectedIds[index] = '';
	}


	data:Array<any>;
	rows:Array<any> = [];
	page:number = 1;
	itemsPerPage:number = 5;
	maxSize:number = 5;
	numPages:number = 1;
	length:number = 0;

	config;
	configs:any = this.columnsRead.map(columns => ({
		paging: true,
		sorting: {columns: columns},
		filtering: {filterString: ''}
	}));

	/*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
		let start = (page.page - 1) * page.itemsPerPage;
		let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
		return data.slice(start, end);
	}

	changeSort(data:any, config:any):any {
		if (!config.sorting) {
			return data;
		}

		let columns = this.config.sorting.columns || [];
		let columnName:string;
		let sort:string;

		for (let i = 0; i < columns.length; i++) {
			if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
				columnName = columns[i].name;
				sort = columns[i].sort;
			}
		}

		if (!columnName) {
			return data;
		}

		// simple sorting
		return data.sort((previous:any, current:any) => {
			if (previous[columnName] > current[columnName]) {
				return sort === 'desc' ? -1 : 1;
			} else if (previous[columnName] < current[columnName]) {
				return sort === 'asc' ? -1 : 1;
			}
			return 0;
		});
	}

	changeFilter(data:any, config:any):any {
		let filteredData:Array<any> = data;
		this.columnsRead[this.currentReadIndex].forEach((column:any) => {
			if (column.filtering) {
				filteredData = filteredData.filter((item:any) => {
					return item[column.name].match(column.filtering.filterString);
				});
			}
		});

		if (!config.filtering) {
			return filteredData;
		}

		if (config.filtering.columnName) {
			return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
		}

		let tempArray:Array<any> = [];
		filteredData.forEach((item:any) => {
			let flag = false;
			this.columnsRead[this.currentReadIndex].forEach((column:any) => {
				if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
					flag = true;
				}
			});
			if (flag) {
				tempArray.push(item);
			}
		});
		filteredData = tempArray;

		return filteredData;
	}

	onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
		if (config.filtering) {
			Object.assign(this.config.filtering, config.filtering);
		}

		if (config.sorting) {
			Object.assign(this.config.sorting, config.sorting);
		}

		let filteredData = this.changeFilter(this.data, this.config);
		let sortedData = this.changeSort(filteredData, this.config);
		this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
		this.length = sortedData.length;
	}

	//////////////////////////////////////////////////////////////////////////////////////////////READ MODAL DATA

}
